<template>
  <div
    id="breadcrumbs"
    aria-label="Breadcrumb"
    class="mx-auto max-w-screen-xl lg:px-8"
  >
    <ul
      class="flex items-center gap-1.5 border-b border-grey-300 px-6 py-6 text-xs text-grey-600 sm:gap-2 sm:text-sm md:gap-3 md:px-8 md:text-base lg:px-4 lg:!text-lg"
    >
      <li class="max-xs:hidden">
        <NuxtLink to="https://www.aussiebroadband.com.au/">
          <span class="sr-only">Home</span>
          <IconHouse class="size-4 shrink-0 fill-grey-600 lg:size-[18px]" />
        </NuxtLink>
      </li>

      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
        class="flex w-max items-center overflow-hidden sm:gap-1 md:gap-3"
        :class="{
          'max-xs:min-w-[40%] max-xs:flex-1': index === breadcrumbs.length - 1,
        }"
      >
        <IconSlash
          class="size-4 shrink-0 fill-grey-600"
          :class="{ 'max-xs:hidden': index === 0 }"
        />

        <span
          v-if="index !== breadcrumbs.length - 1"
          class="flex min-w-0 items-center gap-2 md:gap-3"
        >
          <NuxtLink
            class="truncate capitalize text-link no-underline hover:text-link-hover hover:underline"
            :to="breadcrumb.path"
            :aria-current="ariaCurrent(index)"
          >
            {{ breadcrumb.name }}
          </NuxtLink>
        </span>
        <span v-else class="truncate capitalize text-grey-700">{{
          title ? title : breadcrumb.name
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title?: string;
}>();

const route = useRoute();
const crumbs = route.path.split("/");
const breadcrumbs: { name: string; path: string }[] = [];
const path = ref("");
crumbs.forEach((crumb) => {
  if (crumb !== "") {
    path.value = `${path.value}/${crumb}`;
    const breadcrumb = {
      name: crumb.split("-").join(" "),
      path: path.value + "/",
    };
    if (breadcrumb) {
      breadcrumbs.push(breadcrumb);
    }
  }
});

const ariaCurrent = (index: number) =>
  index === breadcrumbs.length - 1 ? "page" : "false";
</script>
